/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useEffect, useState} from "react";

/**
 * Returns true after `delay` milliseconds has
 * elapsed since the component first rendered.
 * 
 * The second return value is a function which
 * can be used to restart the delay
 * 
 * @param delay
 * @returns [bool, void function()]
 */
export const useDelay = (delay) => {
	const [elapsed, setElapsed] = useState(false);
	
	useEffect(() => {
		if(!elapsed) {
			const handler = setTimeout(() => {
				setElapsed(true);
			}, delay);
			
			return () => {
				clearTimeout(handler);
			};
		}
	}, [elapsed]);
	
	return [elapsed, () => setElapsed(false)];
};
